import * as React from 'react';
import { IModalContextData, ModalContext } from './modal-context';

interface ICloseModalButtonProps {
    onRequestClose(event: React.MouseEvent | React.KeyboardEvent): void;
}

/**
 * Concrete skin for close button shall receive onRequestClose as a prop.
 * This onRequestClose is the handler, specified while rendering particular modal window.
 *
 * @param CloseButtonPresentation
 */
function createCloseButton<T>(
    CloseButtonPresentation: React.ComponentClass<T & ICloseModalButtonProps> | React.FunctionComponent<T & ICloseModalButtonProps>
) {
    class CloseButtonHOC extends React.Component<T & { modalContext: IModalContextData }> {
        componentDidMount(): void {
            this.props.modalContext.handleCloseButtonMounted();
        }

        componentWillUnmount(): void {
            this.props.modalContext.handleCloseButtonUnMounted();
        }

        render() {
            const finalProps = { ...this.props };

            // modalContext is marked as readonly, but we are working on the props copy, so supress error as we are safe to delete it
            // @ts-ignore
            delete finalProps.modalContext;

            return <CloseButtonPresentation {...finalProps} onRequestClose={this.props.modalContext.closeButtonClickHandler} />;
        }
    }

    return (props: T) => (
        <ModalContext.Consumer>
            {context => <CloseButtonHOC { ...props} modalContext={context} />}
        </ModalContext.Consumer>
    );
}

export { createCloseButton, ICloseModalButtonProps };